module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordDetail/images/heart_filled.a16a27a9359cfb885103fa3e93ab01cc.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordDetail/images/heart_filled.svg
// module id = 1670
// module chunks = 1